"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessInstanceHttpClient = void 0;
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class ProcessInstanceHttpClient extends BaseClient_1.BaseClient {
    async query(query, identity, offset, limit, sortSettings, includeXml = true) {
        let url = this.buildUrl(index_1.restSettings.paths.queryProcessInstances, offset, limit, query, sortSettings);
        url = this.addParameterToUrl(url, 'includeXml', includeXml);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            processInstances: response.result.processInstances.map(Mappers_1.mapProcessInstance),
        };
        return mappedResult;
    }
    async getProcessDefinition(processInstanceId, identity) {
        const endpoint = index_1.restSettings.paths.getProcessDefinitionForProcessInstance
            .replace(index_1.restSettings.params.processInstanceId, processInstanceId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const processDefinition = (0, Mappers_1.mapProcessDefinition)(response.result);
        return processDefinition;
    }
    async getProcessModel(processInstanceId, identity) {
        const endpoint = index_1.restSettings.paths.getProcessModelForProcessInstance
            .replace(index_1.restSettings.params.processInstanceId, processInstanceId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const processModel = (0, Mappers_1.mapProcessModel)(response.result);
        return processModel;
    }
    async getProcessInstanceLog(processInstanceId, identity, offset, limit) {
        const endpoint = index_1.restSettings.paths.getLogForProcessInstance
            .replace(index_1.restSettings.params.processInstanceId, processInstanceId);
        const url = this.buildUrl(endpoint, offset, limit);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            logEntries: response.result.logEntries.map(Mappers_1.mapLogEntry),
        };
        return mappedResult;
    }
    async terminateProcessInstance(processInstanceId, identity) {
        const endpoint = index_1.restSettings.paths.terminateProcessInstances
            .replace(index_1.restSettings.params.processInstanceId, processInstanceId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        try {
            await this.httpClient.put(url, {}, requestAuthHeaders);
        }
        catch (error) {
            this.handleError(error);
        }
    }
    async retryProcessInstance(processInstanceId, identity) {
        const endpoint = index_1.restSettings.paths.retryProcessInstance
            .replace(index_1.restSettings.params.processInstanceId, processInstanceId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        try {
            await this.httpClient.put(url, {}, requestAuthHeaders);
        }
        catch (error) {
            this.handleError(error);
        }
    }
    async deleteProcessInstances(processInstanceIds, deleteAllRelatedData = false, identity) {
        const serializedProcessInstanceIds = Array.isArray(processInstanceIds) ? processInstanceIds.join(';') : processInstanceIds;
        let url = this.buildUrl(index_1.restSettings.paths.deleteProcessInstances);
        url = this.addParameterToUrl(url, 'process_instance_ids', serializedProcessInstanceIds);
        if (deleteAllRelatedData) {
            url = this.addParameterToUrl(url, 'delete_all_related_data', deleteAllRelatedData);
        }
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        await this.httpClient.delete(url, requestAuthHeaders);
    }
    // BPMN errors cannot be transmitted across http directly, because their status code need not be a valid HTTP code.
    // Instead, they will be attached as a "bpmnError" property to the error's additionalInformation property.
    handleError(error) {
        var _a;
        if ((_a = error.additionalInformation) === null || _a === void 0 ? void 0 : _a.bpmnError) {
            const errorInfo = error.additionalInformation.bpmnError;
            throw new atlas_engine_sdk_1.DataModels.ProcessInstances.BpmnError(errorInfo.name, errorInfo.code, errorInfo.message);
        }
        throw error;
    }
}
exports.ProcessInstanceHttpClient = ProcessInstanceHttpClient;
//# sourceMappingURL=ProcessInstanceHttpClient.js.map